// extracted by mini-css-extract-plugin
export const linkWrapper = "LinkButton__linkWrapper__2SyKQ";